<div class="col">
  <p-panel [header]="'Client Details' | translateWF: 'Client Details'">
    <p-card>
      <form [formGroup]="clientForm" class="grid-4">
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Client Classification Code' | translateWF: 'Client Classification Code' }}
            </label>
            <csl-dropdown-master-data
              class="w-full"
              formControlName="clientClassificationCode"
              categoryCode="ClientClassification"
              [allowCreate]="true"
              (onDelete)="deleteItemMasterData($event)"
            />
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Industry Code' | translateWF: 'Industry Code' }}
            </label>
            <csl-dropdown-master-data class="w-full" formControlName="industryCode" categoryCode="Industry" [allowCreate]="true" (onDelete)="deleteItemMasterData($event)" />
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Sales Organization Code' | translateWF: 'Sales Organization Code' }}
            </label>
            <csl-dropdown-master-data
              class="w-full"
              formControlName="salesOrganizationCode"
              categoryCode="SalesOrganization"
              [allowCreate]="true"
              (onDelete)="deleteItemMasterData($event)"
            />
          </div>
        </div>

        <div>
          <div class="form-box">
            <label for="">
              {{ 'Distribution Channel Code' | translateWF: 'Distribution Channel Code' }}
            </label>
            <csl-dropdown-master-data
              class="w-full"
              formControlName="distributionChannelCode"
              categoryCode="DistributionChannel"
              [allowCreate]="true"
              (onDelete)="deleteItemMasterData($event)"
            />
          </div>
          <div>
            <div class="form-box">
              <label for="">
                {{ 'Division Code' | translateWF: 'Division Code' }}
              </label>
              <csl-dropdown-master-data class="w-full" formControlName="divisionCode" categoryCode="Division" [allowCreate]="true" (onDelete)="deleteItemMasterData($event)" />
            </div>
          </div>
          <div>
            <div class="form-box">
              <label for="">
                {{ 'Payment Terms' | translateWF: 'Payment Terms' }}
              </label>

              <csl-dropdown-master-data
                class="w-full"
                formControlName="paymentTermsCode"
                categoryCode="PaymentTermsClient"
                [allowCreate]="true"
                (onDelete)="deleteItemMasterData($event)"
              />
            </div>
          </div>
          <div>
            <div class="form-box">
              <label for="">
                {{ 'Account Group Code' | translateWF: 'Account Group Code' }}
              </label>
              <csl-dropdown-master-data
                class="w-full"
                formControlName="accountGroupCode"
                categoryCode="AccountGroup"
                [allowCreate]="true"
                (onDelete)="deleteItemMasterData($event)"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Client Block Reason Code' | translateWF: 'Client Block Reason Code' }}
            </label>

            <csl-dropdown-master-data
              class="w-full"
              formControlName="clientBlockReasonCode"
              categoryCode="ClientBlockReason"
              [allowCreate]="true"
              (onDelete)="deleteItemMasterData($event)"
            />
          </div>
        </div>

        <div>
          <div class="form-box">
            <label for=""> {{ 'SGI Code' | translateWF: 'SGI Code' }} </label>
            <input type="number" id="" pInputText class="w-full" formControlName="sgiCode" />
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for=""> {{ 'CIS Code' | translateWF: 'CIS Code' }} </label>
            <input type="number" id="" pInputText class="w-full" formControlName="cisCode" />
          </div>
          <div>
            <div class="form-box">
              <label for="">
                {{ 'Lead Associate ' | translateWF: 'Lead Associate' }}
              </label>
              <input type="text" id="" pInputText class="w-full" />
              <!-- <p-autocomplete
          fluid="true"
          [dropdown]="true"
          #leadAssociateSearch="cslServerSearch"
          [cslServerSearch]="fetchLeadAssociates"
          [suggestions]="leadAssociateSearch.results()"
        /> -->
            </div>
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Overage Percentage' | translateWF: 'Overage Percentage' }}
            </label>
            <input type="number" id="" pInputText class="w-full" formControlName="overagePercentage" />
          </div>
        </div>
        <div>
          <div class="form-box">
            <label for="">
              {{ 'Shortage Percentage' | translateWF: 'Shortage Percentage' }}
            </label>
            <input type="number" id="" pInputText class="w-full" formControlName="shortagePercentage" />
          </div>
        </div>
      </form>
    </p-card>
  </p-panel>
</div>
